export default {
  nav: {
    technology: "Technologie ODF",
    solutions: "Solutions",
    partnerships: "Partenariats",
    about: "À propos",
    contact: "Nous contacter",
    home: "Accueil",
  },
  hero: {
    eyebrow: "SOLUTIONS ODF DE NOUVELLE GÉNÉRATION",
    headline1: "L'innovation,",
    headline2: "délivrée dans chaque film.",
    copy: "NORTIS met des films orodispersibles (Orally Dissolving Films, ODF) de pointe à la portée des marques de bien-être modernes et des marchés internationaux — en alliant un format pratique à une expertise commerciale fiable.",
    cta1: "Découvrir la technologie ODF",
    cta2: "Devenir partenaire de NORTIS",
    trust: "Conçu pour les modes de vie modernes. Pensé pour les opportunités mondiales.",
    scroll: "Défiler",
  },
  brandline: "Délivrance avancée. Expérience sans effort.",
  credibility: {
    title: "Un format plus intelligent pour un monde en mutation.",
    copy: "Les films orodispersibles offrent une manière raffinée et pratique de délivrer des ingrédients soigneusement formulés — sans l'expérience conventionnelle des comprimés, des gélules ou des liquides.",
  },
  whatIsOdf: {
    eyebrow: "LE FORMAT",
    title: "Qu'est-ce que l'ODF ?",
    copy: "L'ODF est un film oral ultrafin conçu pour se dissoudre facilement dans la bouche. Son format compact offre une alternative moderne aux marques qui développent des expériences de bien-être nomades et conviviales.",
    benefits: [
      { title: "Fin et nomade", desc: "Un format ultraplat qui voyage sans effort — dans une poche, un portefeuille ou un sac." },
      { title: "Utilisation sans eau", desc: "Conçu pour être utilisé partout et à tout moment, sans eau ni préparation." },
      { title: "Présentation précise", desc: "Chaque film est une unité présentée individuellement, conditionnée pour garantir la constance." },
      { title: "Pensé pour l'innovation", desc: "Un support flexible pour des concepts produits modernes et des expériences de marque différenciantes." },
    ],
  },
  whyNortis: {
    eyebrow: "POURQUOI NORTIS",
    title: "Plus qu'un format produit. Une opportunité de marché complète.",
    copy: "NORTIS est le pont entre l'innovation ODF et les marchés commerciaux — en reliant des produits prometteurs aux partenaires capables de les déployer à grande échelle.",
    points: [
      { title: "Expertise commerciale dédiée à l'ODF", desc: "Une spécialisation exclusive dans la catégorie des films orodispersibles et ses dynamiques commerciales." },
      { title: "Sourcing international et développement de marchés", desc: "Identifier les opportunités et construire des voies d'accès aux marchés dans toutes les régions." },
      { title: "Accompagnement en positionnement produit et marque", desc: "Aider nos partenaires à adapter leurs concepts ODF à leurs publics et à leurs canaux." },
      { title: "Modèles de partenariat B2B flexibles", desc: "Distribution, marque propre et développement de marchés — structurés autour de vos objectifs." },
      { title: "Sélection exigeante en matière de qualité", desc: "Évaluation rigoureuse de l'adéquation, de la documentation et de la maturité commerciale." },
      { title: "Relations de long terme", desc: "Des partenariats conçus pour une croissance commerciale durable et cumulative." },
    ],
  },
  solutions: {
    eyebrow: "PORTEFEUILLE DE SOLUTIONS",
    title: "Un portefeuille pensé pour la vie moderne.",
    copy: "Découvrez les catégories de solutions que NORTIS développe avec ses partenaires et sur les marchés du monde entier.",
    viewAll: "Voir toutes les solutions",
    requestInfo: "Demander des informations produit",
    possibilitiesLabel: "Possibilités de développement",
    positioningLabel: "Positionnement commercial",
    availabilityLabel: "Disponibilité sur le marché",
    targetLabel: "Marché cible",
    docLabel: "Statut de la documentation",
    sheetLabel: "Fiche d'information",
    sheetOnRequest: "Disponible sur demande",
    demoBadge: "Concept de démonstration",
    filterAll: "Toutes",
    pageTitle: "Solutions",
    pageSub: "Un portefeuille filtrable de catégories de solutions ODF — structuré pour intégrer de véritables produits au fil du développement des partenariats.",
    demoNote: "Les entrées ci-dessous sont des concepts de démonstration illustrant l'orientation des catégories. Les produits commerciaux réels sont présentés dans le cadre de partenariats actifs.",
  },
  comparison: {
    eyebrow: "EXPÉRIENCE DU FORMAT",
    title: "Le format film face aux autres formats.",
    copy: "Un regard neutre sur les caractéristiques pratiques des formats du quotidien.",
    note: "Comparaison neutre des caractéristiques pratiques des formats uniquement. Aucune affirmation de performance clinique ou d'efficacité.",
    formats: ["Film ODF", "Comprimés", "Gélules", "Liquides"],
    rows: [
      { label: "Portabilité", values: [2, 2, 2, 0] },
      { label: "Utilisation sans eau", values: [2, 0, 0, 1] },
      { label: "Format individuel pré-dosé", values: [2, 2, 2, 0] },
      { label: "Facilité de conservation", values: [2, 2, 1, 0] },
      { label: "Utilisation discrète en déplacement", values: [2, 1, 1, 0] },
    ],
  },
  models: {
    eyebrow: "MODÈLES DE PARTENARIAT",
    title: "Trois façons de construire avec NORTIS.",
    cta: "Discuter d'un partenariat",
    items: [
      { title: "Distribution", desc: "Apportez des produits ODF sélectionnés vers de nouveaux territoires et réseaux commerciaux." },
      { title: "Marque propre", desc: "Développez des concepts ODF différenciants sous votre propre marque." },
      { title: "Développement de marchés", desc: "Construisez avec NORTIS le positionnement produit, la stratégie de lancement et une présence durable sur le marché." },
    ],
  },
  timeline: {
    eyebrow: "COMMENT SE DÉROULE LA COLLABORATION",
    title: "Du premier échange à la croissance sur le marché.",
    steps: [
      { title: "Identification des opportunités", desc: "Nous explorons vos objectifs, vos marchés et les concepts ODF qui y répondent." },
      { title: "Alignement produit et marché", desc: "Associer les bons produits au bon contexte commercial." },
      { title: "Évaluation commerciale", desc: "Structurer les conditions, les volumes et un cadre commercial réaliste." },
      { title: "Conformité et préparation du lancement", desc: "Examen de la documentation et des exigences du marché avant le lancement." },
      { title: "Distribution et croissance", desc: "Accompagnement du déploiement, de l'expansion et de la croissance du partenariat sur le long terme." },
    ],
  },
  quality: {
    eyebrow: "QUALITÉ ET RESPONSABILITÉ",
    title: "La qualité commence par les bonnes questions.",
    copy: "NORTIS évalue l'adéquation des produits, la documentation, la maturité commerciale et les exigences du marché dans le cadre de chaque partenariat potentiel. La disponibilité des produits et leur statut réglementaire peuvent varier selon les pays.",
    placeholder: "Les documents de qualité vérifiés et les certifications seront publiés ici au fur et à mesure de l'avancement des partenariats.",
  },
  global: {
    eyebrow: "VISION MONDIALE",
    title: "Conçu pour la collaboration internationale",
    copy: "Nous travaillons avec des marques, des fournisseurs, des distributeurs et des partenaires commerciaux pour identifier des opportunités ODF pertinentes sur des marchés mondiaux en pleine évolution.",
  },
  finalCta: {
    title: "Façonnons ensemble la nouvelle génération du bien-être oral.",
    copy: "Que vous envisagiez la distribution, la marque propre ou un nouveau concept de produit ODF, NORTIS est prêt à engager la conversation.",
    cta: "Entamer la conversation",
  },
  footer: {
    desc: "NORTIS relie des produits ODF innovants aux marques, partenaires et marchés du monde entier.",
    nav: "Navigation",
    legal: "Mentions légales",
    privacy: "Politique de confidentialité",
    terms: "Conditions d'utilisation",
    language: "Langue",
    disclaimer: "La disponibilité, la formulation, la classification et le statut réglementaire des produits peuvent varier selon les pays. Les informations de ce site sont destinées à des fins commerciales et d'information générale et ne constituent pas un avis médical.",
    rights: "Tous droits réservés.",
  },
  tech: {
    eyebrow: "TECHNOLOGIE ODF",
    title: "La science de la finesse.",
    sub: "Un aperçu pédagogique du film orodispersible — le format, l'expérience et les possibilités commerciales qu'il ouvre.",
    what: {
      title: "Qu'est-ce qu'un film orodispersible ?",
      copy: "Un film orodispersible (ODF) est une feuille ultrafine conçue pour se dissoudre facilement dans la bouche. Au lieu d'avaler un comprimé ou de doser un liquide, l'utilisateur place simplement un film et le laisse se dissoudre — une expérience discrète et moderne dans un format remarquablement compact.",
    },
    structure: {
      title: "La structure générale du film",
      copy: "Sur le plan conceptuel, un ODF associe une base structurelle, une matrice porteuse contenant les ingrédients formulés et une couche sensorielle qui façonne le goût et la texture. Survolez ou touchez le schéma pour séparer les couches conceptuelles.",
      note: "Représentation conceptuelle à titre d'illustration uniquement.",
      layers: [
        { title: "Couche sensorielle", desc: "Façonne le goût, la texture et l'expérience de dissolution." },
        { title: "Matrice porteuse", desc: "Contient les ingrédients soigneusement formulés au sein du film." },
        { title: "Base structurelle", desc: "Confère au film son intégrité, sa finesse et sa stabilité." },
      ],
    },
    experience: {
      title: "L'expérience utilisateur",
      copy: "Pas d'eau. Pas de dosage. Pas d'interruption. Le film se dissout discrètement et s'utilise naturellement en voyage, au travail ou en déplacement. Pour les consommateurs modernes, le format devient lui-même une partie de l'expérience de marque.",
    },
    portability: {
      title: "Portabilité et potentiel d'emballage",
      copy: "Les films individuels peuvent être présentés dans des sachets fins, d'élégants multipacks ou des distributeurs compacts — des formats adaptés aussi bien aux rayons du commerce moderne qu'aux moments d'unboxing en vente directe.",
    },
    development: {
      title: "Possibilités de développement produit",
      copy: "Le format film prend en charge un large éventail de concepts produits — des routines de bien-être quotidiennes aux positionnements lifestyle ciblés — offrant aux marques un espace de différenciation dans des catégories saturées.",
    },
    commercial: {
      title: "Applications commerciales",
      copy: "Les concepts ODF se développent dans les catégories du bien-être, de la beauté in & out, de l'énergie, du sommeil et des ingrédients fonctionnels — des canaux où la praticité et l'expérience premium orientent les décisions d'achat.",
    },
    regulatory: {
      title: "Considérations de marché et réglementaires",
      copy: "La classification et les exigences applicables aux produits sous forme de film diffèrent selon les pays et les formulations. NORTIS aborde chaque marché individuellement, en examinant la documentation et le contexte réglementaire avec ses partenaires avant toute commercialisation.",
    },
    cta: "Demander des informations techniques",
  },
  partnership: {
    eyebrow: "MARQUE PROPRE ET DISTRIBUTION",
    title: "Deux voies. Une même exigence de partenariat.",
    sub: "NORTIS structure ses collaborations commerciales autour de deux modèles principaux — chacun conçu pour la clarté, la rapidité et la croissance à long terme.",
    plTitle: "Marque propre",
    plDesc: "Développez des concepts ODF différenciants sous votre propre marque, NORTIS coordonnant le parcours du concept jusqu'au rayon.",
    plSteps: ["Évaluation du concept", "Sélection des produits", "Coordination du branding et du packaging", "Examen de la documentation", "Préparation du lancement", "Montée en puissance commerciale"],
    distTitle: "Distribution",
    distDesc: "Apportez des produits ODF sélectionnés sur votre territoire et dans votre réseau commercial, avec un accompagnement structuré à chaque étape.",
    distSteps: ["Évaluation du territoire", "Alignement du portefeuille", "Conditions commerciales", "Planification de l'entrée sur le marché", "Accompagnement au lancement", "Croissance à long terme"],
    formTitle: "Déposer une demande de partenariat",
    formSub: "Parlez-nous de vos objectifs et notre équipe vous répondra avec les prochaines étapes.",
  },
  about: {
    eyebrow: "À PROPOS DE NORTIS",
    title: "Concentrés sur le format qui façonne demain.",
    copy: "NORTIS a été créé pour relier les innovations ODF prometteuses aux marques, partenaires et marchés capables de les transformer en produits commerciaux significatifs. Nous conjuguons rapidité entrepreneuriale, vision internationale et approche disciplinée des partenariats de long terme.",
    positioning: "NORTIS relie des produits ODF innovants aux marques, partenaires et marchés du monde entier.",
    principlesTitle: "Nos principes",
    principles: [
      { title: "Précision", desc: "Le soin du détail — de l'évaluation des produits à la communication avec les partenaires." },
      { title: "Confiance", desc: "Des attentes transparentes et des engagements que nous entendons tenir." },
      { title: "Progrès", desc: "Une orientation résolue vers l'avenir et les formats modernes." },
      { title: "Partenariat", desc: "Des relations conçues pour se renforcer au fil des années, pas des trimestres." },
      { title: "Perspective mondiale", desc: "Penser au-delà des frontières, des marchés et des cultures de consommation." },
    ],
  },
  contact: {
    eyebrow: "CONTACT",
    title: "Entamons la conversation.",
    sub: "Partagez quelques détails sur votre projet et notre équipe reviendra vers vous.",
    name: "Nom complet",
    company: "Société",
    email: "E-mail professionnel",
    country: "Pays",
    website: "Site web",
    interest: "Type de partenariat souhaité",
    market: "Marché ou territoire visé",
    message: "Message",
    consent: "J'autorise NORTIS à conserver mes coordonnées afin de répondre à cette demande.",
    submit: "Envoyer le message",
    sending: "Envoi en cours…",
    successTitle: "Merci — votre message a bien été reçu.",
    successCopy: "Notre équipe examinera votre demande et vous répondra dans les meilleurs délais.",
    successAnother: "Envoyer un autre message",
    errorRequired: "Ce champ est obligatoire.",
    errorEmail: "Veuillez saisir une adresse e-mail professionnelle valide.",
    errorConsent: "Votre consentement est requis pour envoyer le formulaire.",
    errorSubmit: "Une erreur est survenue. Veuillez réessayer.",
    optional: "Facultatif",
    interests: {
      distribution: "Distribution",
      privateLabel: "Marque propre",
      sourcing: "Sourcing de produits",
      marketDev: "Développement de marchés",
      general: "Partenariat général",
      product: "Informations produit",
      technical: "Informations techniques",
    },
    selectPlaceholder: "Sélectionnez une option",
  },
  legal: {
    privacyTitle: "Politique de confidentialité",
    termsTitle: "Conditions d'utilisation",
    updated: "Dernière mise à jour",
    privacy: [
      { h: "1. Présentation", p: "Cette politique de confidentialité explique comment NORTIS collecte, utilise et protège les informations transmises via ce site web. Nous nous engageons à traiter les coordonnées professionnelles de manière responsable et transparente." },
      { h: "2. Informations collectées", p: "Lorsque vous soumettez un formulaire de contact ou de partenariat, nous collectons les informations que vous fournissez, telles que votre nom, votre société, votre e-mail professionnel, votre pays, votre site web, votre domaine d'intérêt et le contenu de votre message." },
      { h: "3. Utilisation des informations", p: "Les informations transmises sont utilisées uniquement pour répondre à votre demande, évaluer une collaboration commerciale potentielle et communiquer avec vous sur les sujets de partenariat pertinents. Nous ne vendons pas de données personnelles." },
      { h: "4. Stockage et sécurité des données", p: "Les soumissions de formulaires sont stockées de manière sécurisée dans la base de données de notre application. L'accès est limité au personnel qui en a besoin pour répondre aux demandes. Nous prenons des mesures techniques raisonnables pour protéger les données stockées." },
      { h: "5. Durée de conservation", p: "Nous conservons les données des demandes aussi longtemps que nécessaire à la gestion de la relation commerciale ou conformément à la législation applicable. Vous pouvez demander la suppression de vos données en nous contactant." },
      { h: "6. Vos droits", p: "Selon votre juridiction, vous pouvez disposer de droits d'accès, de rectification ou de suppression des données personnelles que nous détenons à votre sujet. Pour exercer ces droits, veuillez nous contacter via le site web." },
      { h: "7. Modifications de cette politique", p: "Nous pouvons mettre à jour cette politique de confidentialité de temps à autre. Les modifications importantes seront indiquées sur cette page avec une date de révision actualisée." },
    ],
    terms: [
      { h: "1. Acceptation des conditions", p: "En accédant à ce site web et en l'utilisant, vous acceptez les présentes conditions d'utilisation. Si vous n'êtes pas d'accord, veuillez cesser d'utiliser le site." },
      { h: "2. Finalité informative", p: "Le contenu de ce site web est fourni uniquement à des fins commerciales et d'information générale. Il ne constitue pas un avis médical, juridique ou réglementaire, et aucun contenu ne doit être interprété comme une allégation produit." },
      { h: "3. Disponibilité des produits", p: "La disponibilité, la formulation, la classification et le statut réglementaire des produits peuvent varier selon les pays. Rien sur ce site ne constitue une offre de vente d'un produit dans une juridiction donnée." },
      { h: "4. Propriété intellectuelle", p: "Le nom NORTIS, l'identité visuelle et le contenu du site web sont la propriété de NORTIS. Vous ne pouvez pas reproduire ni diffuser le contenu du site sans autorisation écrite préalable." },
      { h: "5. Limitation de responsabilité", p: "NORTIS s'efforce raisonnablement de maintenir l'exactitude des informations du site, sans toutefois en garantir l'exhaustivité. Dans la mesure permise par la loi, NORTIS décline toute responsabilité quant aux décisions prises sur la base du contenu du site." },
      { h: "6. Liens tiers", p: "Ce site peut contenir des liens vers des ressources tierces. NORTIS n'est pas responsable du contenu ni des pratiques des sites externes." },
      { h: "7. Portée des conditions", p: "Ces conditions peuvent être mises à jour périodiquement. La poursuite de l'utilisation du site vaut acceptation de la version en vigueur." },
    ],
  },
  seo: {
    home: { title: "NORTIS — Solutions ODF avancées | Partenaire en films orodispersibles", desc: "NORTIS relie des produits innovants sous forme de films orodispersibles (ODF) aux marques, partenaires et marchés du monde entier. Distribution, marque propre et développement de marchés." },
    tech: { title: "Technologie ODF — NORTIS", desc: "Un aperçu pédagogique de la technologie des films orodispersibles : format, structure, expérience utilisateur et possibilités commerciales." },
    solutions: { title: "Portefeuille de solutions ODF — NORTIS", desc: "Découvrez les catégories de solutions ODF : bien-être quotidien, énergie, beauté, sommeil, ingrédients fonctionnels et concepts en marque propre." },
    partnership: { title: "Marque propre et distribution — NORTIS", desc: "Devenez partenaire de NORTIS via les modèles de distribution, de marque propre ou de développement de marchés pour les produits ODF." },
    about: { title: "À propos de NORTIS — Concentrés sur le format de demain", desc: "NORTIS relie les innovations ODF prometteuses aux marques, partenaires et marchés capables d'en faire des produits commerciaux." },
    contact: { title: "Contacter NORTIS — Entamer la conversation", desc: "Contactez l'équipe NORTIS pour discuter de distribution ODF, de marque propre, de sourcing ou de développement de marchés." },
    privacy: { title: "Politique de confidentialité — NORTIS", desc: "Comment NORTIS collecte, utilise et protège les informations transmises via ce site web." },
    terms: { title: "Conditions d'utilisation — NORTIS", desc: "Conditions régissant l'utilisation du site web NORTIS et de son contenu informatif." },
  },
  a11y: {
    mainNav: "Navigation principale",
    mobileNav: "Navigation mobile",
    homeLink: "Accueil NORTIS",
    openMenu: "Ouvrir le menu",
    closeMenu: "Fermer le menu",
    langSelector: "Choisir la langue",
    filmDiagram: "Schéma interactif des couches du film",
    linkedinLabel: "NORTIS sur LinkedIn",
    techImageAlt: "Feuilles de film superposées abstraites",
    yes: "Oui",
    partial: "Partiel",
    no: "Non",
    filters: "Filtres de solutions",
  },
  solutionsData: {
    "daily-wellness": {
      name: "Bien-être quotidien",
      desc: "Des concepts de films pensés pour s'intégrer naturellement aux routines modernes du matin et du soir.",
      possibilities: ["Gammes de produits axées sur les routines", "Formats adaptés à l'abonnement", "Packaging premium minimaliste"],
      positioning: "Positionné pour les consommateurs en quête d'une régularité quotidienne sans effort.",
      availability: "En développement avec des partenaires",
      targetMarket: "Distribution bien-être et lifestyle",
      docStatus: "Préparée par marché",
    },
    "energy-performance": {
      name: "Énergie et performance",
      desc: "Des concepts nomades pour les consommateurs qui privilégient le dynamisme — avant l'entraînement, un voyage ou une journée exigeante.",
      possibilities: ["Positionnement pré-activité", "Formats multipacks compacts", "Langage de marque audacieux et moderne"],
      positioning: "Conçu pour des moments de consommation rapides, guidés par la praticité.",
      availability: "En développement avec des partenaires",
      targetMarket: "Circuits lifestyle actif et sport",
      docStatus: "Préparée par marché",
    },
    "beauty-aging": {
      name: "Beauté et bien vieillir",
      desc: "Des concepts de films élégants pour la catégorie de la beauté in & out, où l'expérience et l'esthétique comptent.",
      possibilities: ["Positionnement beauté premium", "Concepts de packaging à offrir", "Storytelling de marque axé sur le rituel"],
      positioning: "Un format raffiné pour les marques qui subliment le rituel beauté quotidien.",
      availability: "En développement avec des partenaires",
      targetMarket: "Beauté in & out et distribution premium",
      docStatus: "Préparée par marché",
    },
    "sleep-relaxation": {
      name: "Sommeil et détente",
      desc: "Des concepts apaisants, orientés vers le soir, conçus autour de la simplicité en fin de journée.",
      possibilities: ["Positionnement en rituel du soir", "Formats discrets pour la table de nuit", "Design sensoriel apaisant"],
      positioning: "Conçu pour le moment de calme qui précède le repos.",
      availability: "En développement avec des partenaires",
      targetMarket: "Bien-être du soir et pharmacies",
      docStatus: "Préparée par marché",
    },
    "vitamins-functional": {
      name: "Vitamines et ingrédients fonctionnels",
      desc: "Des concepts de films construits autour d'ingrédients fonctionnels reconnus, présentés dans un format moderne et précis.",
      possibilities: ["Familles de produits axées sur les ingrédients", "Design d'étiquette clair et honnête", "Différenciation par le format"],
      positioning: "Une alternative contemporaine au sein de catégories d'ingrédients établies.",
      availability: "En développement avec des partenaires",
      targetMarket: "Distribution nutraceutique et fonctionnelle",
      docStatus: "Préparée par marché",
    },
    "custom-private-label": {
      name: "Concepts sur mesure et marque propre",
      desc: "Une toile vierge : des concepts ODF sur mesure développés sous la marque du partenaire, de l'idée au lancement.",
      possibilities: ["Développement de concept entièrement sur mesure", "Coordination de la marque et du packaging", "Accompagnement au lancement et à la montée en puissance"],
      positioning: "Pour les partenaires qui veulent un produit différenciant, indéniablement le leur.",
      availability: "Ouvert aux briefs",
      targetMarket: "Propriétaires de marques et distributeurs",
      docStatus: "Définie par projet",
    },
  },
};
